// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PlanPackageStepQuery = { __typename?: 'Query', planPackages: { __typename?: 'PlanPackagesPageResult', entities: Array<{ __typename?: 'PlanPackage', id: string, name: string, description?: string | null | undefined, code?: string | null | undefined, programData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined }, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } }> }> } };

export type CreateOfferingPlanPackageFragment = { __typename?: 'PlanPackage', id: string, name: string, description?: string | null | undefined, code?: string | null | undefined, programData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined }, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } }> };

export type CreateOfferingPlanPackage_AssetFragment = { __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } };

export const CreateOfferingPlanPackage_AssetFragmentDoc = gql`
    fragment CreateOfferingPlanPackage_Asset on ReadyPlanAsset {
  id
  asset {
    id
    previewUrl(resizing: {width: 321, region: FULL})
  }
  type {
    code
  }
}
    `;
export const CreateOfferingPlanPackageFragmentDoc = gql`
    fragment CreateOfferingPlanPackage on PlanPackage {
  id
  name
  description
  code
  programData {
    id
    bedrooms
    fullBaths
    sellableSqft
    depthInFeet
    widthInFeet
  }
  minProgramData {
    id
    bedrooms
    fullBaths
    sellableSqft
    depthInFeet
    widthInFeet
  }
  maxProgramData {
    id
    bedrooms
    fullBaths
    sellableSqft
    depthInFeet
    widthInFeet
  }
  options {
    id
    active
    type {
      id
      isElevation
    }
  }
  assets {
    ...CreateOfferingPlanPackage_Asset
  }
}
    ${CreateOfferingPlanPackage_AssetFragmentDoc}`;
export const PlanPackageStepDocument = gql`
    query PlanPackageStep {
  planPackages(filter: {status: ACTIVE}) {
    entities {
      ...CreateOfferingPlanPackage
    }
  }
}
    ${CreateOfferingPlanPackageFragmentDoc}`;

/**
 * __usePlanPackageStepQuery__
 *
 * To run a query within a React component, call `usePlanPackageStepQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageStepQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanPackageStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlanPackageStepQuery, PlanPackageStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageStepQuery, PlanPackageStepQueryVariables>(PlanPackageStepDocument, options);
      }
export function usePlanPackageStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageStepQuery, PlanPackageStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageStepQuery, PlanPackageStepQueryVariables>(PlanPackageStepDocument, options);
        }
// @ts-ignore
export function usePlanPackageStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageStepQuery, PlanPackageStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageStepQuery, PlanPackageStepQueryVariables>;
export function usePlanPackageStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageStepQuery, PlanPackageStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageStepQuery | undefined, PlanPackageStepQueryVariables>;
export function usePlanPackageStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageStepQuery, PlanPackageStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageStepQuery, PlanPackageStepQueryVariables>(PlanPackageStepDocument, options);
        }
export type PlanPackageStepQueryHookResult = ReturnType<typeof usePlanPackageStepQuery>;
export type PlanPackageStepLazyQueryHookResult = ReturnType<typeof usePlanPackageStepLazyQuery>;
export type PlanPackageStepSuspenseQueryHookResult = ReturnType<typeof usePlanPackageStepSuspenseQuery>;
export type PlanPackageStepQueryResult = ApolloReactCommon.QueryResult<PlanPackageStepQuery, PlanPackageStepQueryVariables>;